export default {
    newPageCreateFile: "파일을 만드는 중입니다",
    globalConfirm: "확인",
    globalCancel: "취소",
};
